// Fetch a PDF from the API (with the session token) and show it in a new tab — the
// "Preview" behind every email composer, so what's about to be attached can be read
// before Send. Opens the tab first so phone browsers don't swallow it as a pop-up.
import { API_BASE, getToken } from '../services/apiClient';

export async function openPdfFrom(path, { method = 'GET', body } = {}) {
  const win = window.open('', '_blank');
  try {
    const r = await fetch(`${API_BASE}${path}`, {
      method,
      headers: { 'x-worker-token': getToken(), ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}) },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!r.ok) {
      let msg = `Could not draw the preview (${r.status}).`;
      try { const j = await r.json(); if (j && j.error) msg = j.error; } catch {}
      throw new Error(msg);
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    if (win) win.location.href = url; else window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return true;
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}
export default openPdfFrom;
